import { Footer } from "../Footer";
import { Theme } from "../NavBar";
import { SignupCTAAlt } from "../Sections/SignupCTAAlt";
import * as React from "react";

export const SharedLayout = (props: Theme) => {
  const theme = props.theme;

  const classes = theme === "dark-theme" ? "tw-bg-black" : "tw-bg-white";

  return (
    <div className={classes}>
      <section className={"section section-end-cta-dark"}>
        <SignupCTAAlt />
        <Footer className="footer-dark" />
      </section>
    </div>
  );
};
